import type { RefinementListProvided } from 'react-instantsearch-core';
import { connectRefinementList } from 'react-instantsearch-dom';

import { FC, useMemo, useRef } from 'react';

import { Button, Form, InputGroup } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import { BsCaretDownFill } from 'react-icons/bs';

export const FilterByCountriesInner: FC<RefinementListProvided> = ({
  items,
  currentRefinement,
  refine,
}) => {
  const options = useMemo(
    () =>
      items
        // remove options the user has already selected
        .filter((item) => !item.isRefined)
        .map((item) => `${item.label} (${item.count})`),
    [items],
  );

  const typeAheadRef = useRef(null);

  const filterBySelected = (selected: string[]): void => {
    // remove the values in bracket
    const transformSelected = selected.map((value) => value.split(' (')[0]);
    refine(transformSelected);
  };

  return (
    <Form.Group controlId="countries">
      <Form.Label>Country</Form.Label>
      <InputGroup>
        <Typeahead
          id="filterByCountries"
          selected={currentRefinement}
          multiple
          placeholder="Select..."
          ref={typeAheadRef}
          onBlur={() => (typeAheadRef.current as any).toggleMenu()}
          onChange={filterBySelected}
          options={options}
          inputProps={
            {
              'data-testid': 'filterByCountries',
            } as unknown
          }
        />
        <Button
          onClick={() => (typeAheadRef.current as any).toggleMenu()}
          variant="light"
          style={{
            background: 'none',
            border: '1px solid #ced4da',
          }}
        >
          <BsCaretDownFill />
        </Button>
      </InputGroup>
    </Form.Group>
  );
};

const FilterByCountries = connectRefinementList(FilterByCountriesInner);

export default FilterByCountries;
